import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';
import { cn } from '../lib/utils';

/**
 * @param {{ className?: string, dataTestId?: string } & React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>} props
 */
function Checkbox({ className, dataTestId, ...props }) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      data-testid={dataTestId}
      className={cn(
        // Checked state is --brand, matching RadioGroupItem and the primary button. Was
        // --primary, which is navy in light but near-white in dark — a different colour per mode.
        'peer border-line-input data-[state=checked]:bg-brand data-[state=checked]:text-white data-[state=checked]:border-brand aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        <CheckIcon className="size-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
